import { AxiosError } from 'axios';
import { useRouter } from 'next/router';
import { useMutation, useQueryClient } from 'react-query';

import { ServerStateKeysEnum } from 'reactQuery/constants';
import { iteroCartService } from 'services';
import { AddScannerLineItemParams, Cart } from 'types';
import { displayNotification, pushToGTM } from 'utils';
import { useI18n } from '../../../contexts/i18n';

export const useAddIteroLineItem = () => {
  const i18n = useI18n();
  const router = useRouter();

  const queryClient = useQueryClient();
  return useMutation(
    ({
      variantId,
      quantity,
      scannerType,
      scannerServiceType,
      itemPrice,
    }: AddScannerLineItemParams) => {
      return iteroCartService.addScannerLineitem(
        variantId,
        quantity,
        scannerType,
        scannerServiceType,
        itemPrice
      );
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.setQueriesData(
          [`${ServerStateKeysEnum.userIteroCart}`],
          data
        );
        pushAddToCartEventToGTM(data);
        router.push('/');
      },
      onError: (err: AxiosError<{ error: string }>) => {
        const errMessage =
          err?.response?.data?.error ?? i18n['Failed to add to Cart!'];
        displayNotification(errMessage, 'danger');
      },
    }
  );
};

const pushAddToCartEventToGTM = (data: Cart) => {
  const currentLineItem = data.lineItems[data.lineItems.length - 1];

  pushToGTM('add_to_cart', {
    ecommerce: {
      currency: data.currency,
      value: currentLineItem.price,
      items: [
        {
          item_id: currentLineItem.slug,
          item_name: currentLineItem.name,
          affiliation: 'Global Store NA',
          price: currentLineItem.price,
          currency: data.currency,
          quantity: currentLineItem.quantity,
        },
      ],
    },
  });
};
